module.exports = __webpack_public_path__ + "img/logo-yobo.c26fa79d.png";